<template lang="pug">
  .b-error-page
    ._code {{ code }}
    h1._description {{ description }}
    Btn._go-home(:to="{ name: 'home' }" large) Вернуться на главную
</template>

<script>
export default {
  name: 'ErrorPage',
  props: {
    code: Number,
  },
  computed: {
    description() {
      const errors = [
        { code: 403, description: 'Доступ запрещен' },
        { code: 404, description: 'Страница не найдена' },
      ];

      const foundError = errors.find((e) => e.code === this.code);

      return foundError?.description ?? 'Неизвестная ошибка';
    },
  },
};
</script>

<style scoped lang="scss">

.error-page {
  height: 100%;
  display: flex;
  flex-direction: column;
  gap:40px;
  justify-content: center;
  align-items: center;

  &__code {
     font-size: 50px;
  }

  &__description {
    font-size: 30px;
  }
}

</style>
